module.exports = __webpack_public_path__ + "static/langojango-french-language-phrasebook-ee49610e0c0ba4cccb079215c2e204af.png";